import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StockPackingHistoryAction } from './stock-packing-history.actions';
import {
  StockPackingHistoryListContent,
  StockPackingHistorySearchCriteria,
  StockPackingHistoryViewResponse
} from '../../model/stock-packing-history.model';

export interface StockPackingHistoryState extends EntityState<StockPackingHistoryListContent> {
  isLoading: boolean;
  selected: StockPackingHistoryListContent[];
  criteriaObject: StockPackingHistorySearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewResponse: StockPackingHistoryViewResponse;
}

export const adapter: EntityAdapter<StockPackingHistoryListContent> =
  createEntityAdapter<StockPackingHistoryListContent>({
    selectId: (model: StockPackingHistoryListContent) => model.recallNo
  });

export const initialState: StockPackingHistoryState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewResponse: null
});

export const StockPackingHistoryReducer = createReducer<StockPackingHistoryState>(
  initialState,
  on(StockPackingHistoryAction.responseList, (state, action): StockPackingHistoryState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
